import {
  NuvemEnvioCreateDispatchesRequestDto,
  NuvemEnvioCreateDispatchesResponseDto,
  NuvemEnvioSimulateDispatchChargeRequestDto,
  NuvemEnvioSimulateDispatchChargeResponseDto,
  NuvemEnvioCreateCreditRechargeRequestDto,
  NuvemEnvioCreateCreditRechargeResponseDto,
  NuvemEnvioSearchLabelsRequestDto,
  NuvemEnvioSearchLabelsResponseDto,
  NuvemEnvioDownloadLabelsRequestDto,
  NuvemEnvioDownloadLabelsResponseDto,
  NuvemEnvioCreateLabelsRequestDto,
  NuvemEnvioCreateLabelsResponseDto,
} from '@tiendanube/common';
import axios from 'App/axios';

const createNuvemEnvioLabels = async (
  payload: NuvemEnvioCreateDispatchesRequestDto,
): Promise<NuvemEnvioCreateDispatchesResponseDto> => {
  const { data } = await axios.post('nuvem-envio/dispatches', payload);
  return data;
};

const simulateNuvemEnvioLabels = async (
  payload: NuvemEnvioSimulateDispatchChargeRequestDto,
): Promise<NuvemEnvioSimulateDispatchChargeResponseDto> => {
  const { data } = await axios.post(
    'nuvem-envio/dispatches/simulate-charge',
    payload,
  );
  return data;
};

const creditRechargeNuvemEnvioLabels = async (
  payload: NuvemEnvioCreateCreditRechargeRequestDto,
): Promise<NuvemEnvioCreateCreditRechargeResponseDto> => {
  const { data } = await axios.post(
    'nuvem-envio/statement/credit-recharges',
    payload,
  );
  return data;
};

const createNuvemEnvioAsyncLabels = async (
  payload: NuvemEnvioCreateLabelsRequestDto,
): Promise<NuvemEnvioCreateLabelsResponseDto> => {
  const response = await axios.post<NuvemEnvioCreateLabelsResponseDto>(
    'nuvem-envio/labels',
    payload,
  );
  return response.data;
};

const searchForNuvemEnvioLabels = async (
  payload: NuvemEnvioSearchLabelsRequestDto,
): Promise<NuvemEnvioSearchLabelsResponseDto> => {
  const response = await axios.post<NuvemEnvioSearchLabelsResponseDto>(
    'nuvem-envio/labels/search',
    payload,
  );
  return response.data;
};

const downloadNuvemEnvioLabels = async (
  payload: NuvemEnvioDownloadLabelsRequestDto,
): Promise<NuvemEnvioDownloadLabelsResponseDto> => {
  const response = await axios.post<NuvemEnvioDownloadLabelsResponseDto>(
    'nuvem-envio/labels/download',
    payload,
  );
  return response.data;
};

export default {
  createNuvemEnvioLabels,
  simulateNuvemEnvioLabels,
  creditRechargeNuvemEnvioLabels,
  createNuvemEnvioAsyncLabels,
  searchForNuvemEnvioLabels,
  downloadNuvemEnvioLabels,
};
